import * as api from '../../../api';

export const loadPolices = async id => {
    const url = `/api/organization/${id}/policies`;
    const { data, storage_region } = await api.get(url);
    return {
        policies: data,
        storageRegion: storage_region,
    };
};

export const updatePolicy = async (id, policy) => {
    const { data } = await api.patch(
        `/api/organization/${id}/policies`,
        policy
    );
    return data[0];
};
